import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';

import adminReducer from './admin.reducer';
import approvalFormReducer from './approvalForm.reducer';
import authenticationReducer from './authentication.reducer';
import commonReducer from './common.reducer';
import contactsFormReducer from './contactForm.reducer';
import registrationReducer from './registration.reducer';
import sambandhApprovalReducer from './sambandh.reducer';
import userAccessReducer from './userAccess.reducer';
import followUp from '../views/FollowUp/followUp.ducks';
import followUpDetails from '../views/FollowUpDetails/followUpDetails.ducks';

// v2
import accessForm from '../v2/containers/AccessContainer/accessForm.ducks';
import admin from '../views/Admin/admin.duck';
import contacts from '../views/Contacts/contacts.ducks';

const rootReducer = combineReducers({
  adminData: adminReducer,
  approvalForm: approvalFormReducer,
  auth: authenticationReducer,
  commonData: commonReducer,
  contactForm: contactsFormReducer,
  contactsData: contacts,
  form,
  registration: registrationReducer,
  sambandhApproval: sambandhApprovalReducer,
  userAccess: userAccessReducer,
  followUp,
  followUpDetails,
  accessForm,
  admin,
});

export default rootReducer;
